export interface SidebarMenu { path:string; children?:SidebarMenu[] }
const normalize=(path:string)=>String(path||'').split(/[?#]/)[0].replace(/\/$/,'') || '/'
// 仅从当前已授权菜单定位，不创建入口；优先最具体路径，再匹配路由父级。
export function locateSidebar(menus:SidebarMenu[],paths:string[]) {
 const leaves=menus.flatMap(parent=>parent.children?.length?parent.children.map(child=>({path:child.path,parent:parent.path})):[{path:parent.path,parent:''}])
 for(const path of paths){const current=normalize(path);const match=leaves.filter(item=>current===normalize(item.path)||current.startsWith(normalize(item.path)+'/')).sort((a,b)=>normalize(b.path).length-normalize(a.path).length)[0]
  if(match)return {selected:[match.path],parent:match.parent}
 }
 return {selected:[] as string[],parent:''}
}
export function validSidebarOpenKeys(menus:SidebarMenu[],keys:string[]) {
 const available=new Set(menus.filter(menu=>menu.children?.length).map(menu=>menu.path))
 return Array.from(new Set(keys)).filter(key=>available.has(key))
}
export function sidebarIcon(icon:unknown,path:string,available:Set<string>):string {
 const original=String(icon||'').trim()
 if(/^https?:\/\//i.test(original))return original
 const name=original.replace(/^#?icon-/,'')
 if(available.has(name))return name
 const category=path.split('/')[1]
 const fallback:Record<string,string>={customers:'user',orders:'outorder',products:'cloth',platform:'role',system:'setting',financial:'financial',inventory:'inventory'}
 return fallback[category] || 'dashboard'
}
